<template>
    <el-dialog v-model="dialog_opened" width="90%" :before-close="close" :close-on-click-modal="false">
        <el-row style="margin-bottom: 70px">
            <el-col :span="17" :xl="20">
                <el-form label-width="100px">
                    <el-form-item label="放大倍数">
                        <el-slider v-model="unit" :max="10" :min="1" :step="1" style="width: 500px"
                                   :disabled="loading"></el-slider>
                    </el-form-item>
                </el-form>
                <div v-loading="loading" ref="hooper" v-if="image" style="justify-content: left;display: flex;">
                    <div style="position: relative;" id="rectangle">
                        <canvas ref="colored" id="colored"
                                :style="{width: width * unit + 'px', height: height * unit + 'px'}"></canvas>
                        <canvas ref="canvas" id="region"
                                style="position: absolute;top: 0;left: 0" :width="width" :height="height"
                                :style="{width: width * unit + 'px', height: height * unit + 'px'}"></canvas>
                    </div>
                </div>
                <div style="display: flex; justify-content: left; margin-left: 0; margin-right: 30px; flex-wrap: wrap">
                  <div v-for="(color, index) in this.remaining_colors" @click="clickColor(color)" class="circle"
                       :style="{ backgroundColor: color, color: this.getLabelColor(color) }"
                       :class="(this.activeColor === color ? 'active': '')">
                    {{ index + 1 }}
                  </div>
                </div>
            </el-col>
            <el-col :span="7" :xl="4">
<!--                <el-radio-group v-model="mode" @change="switchMode"-->
<!--                                :disabled="loading || image && [1].includes(image.status)">-->
<!--                    <el-radio :label="1">排序</el-radio>-->
<!--                    <el-radio :label="2">编辑</el-radio>-->
<!--                  &lt;!&ndash;  <el-radio :label="2">改颜色</el-radio>&ndash;&gt;-->
<!--                </el-radio-group>-->
<!--                <template>-->
                    <div>
                        <el-button type="primary" @click="tryToColor" v-if="play===0">模拟涂色</el-button>
                        <el-button type="primary" @click="pauseColor" v-else-if="play===1">暂停涂色</el-button>
                        <el-button type="primary" @click="continueColor" v-else-if="play===2">继续涂色</el-button>
                        <el-button type="success" @click="tryToColor" v-if="play>0">重新涂色</el-button>
                        <el-button type="danger" @click="clearColor">清除颜色</el-button>
                    </div>
                    <h3>区域</h3>
<!--                      <div  v-if="mode===1" style="display: flex;flex-wrap: wrap;">-->
<!--                        <div class="circle" v-for="(t, i) in this.region_circles" :style="{backgroundColor: `rgb(${t}, ${t}, ${t})`}"-->
<!--                             @click="changeActive(i)"-->
<!--                             :class="(i >= this.region_circles.length / 2 ? 'dark': 'light') + (selected_region === i? ' active': '')">-->
<!--                          {{ region_colors[i].length }}-->
<!--                        </div>-->
<!--                      </div>-->
                    <el-scrollbar :max-height="height * unit" style="padding-bottom: 0;">
                      <vue-draggable-next v-model="region_colors" :animation="300"
                                          @start="onDragStart"
                                          @end="(e) => onDragEnd(e, -1)"
                                          :move="onDragMove"
                                          handle=".region-handle">
                        <div v-for="(region, index) in region_colors" :key="index" :id="'item-'+ index"
                             style="display: flex; align-items: center; justify-content: space-between;">

                          <div v-if="region.length > 0"
                              :class="['color-section', this.selected_region === index ? 'section-acitve' : '']"
                               @click="(event)=>changeActive(event,index)" class="region-handle" >
                            <vue-draggable-next v-model="region_colors[index]" :animation="300" handle=".color-handle"
                                                @start="onDragStart"
                                                @end="(e) => onDragEnd(e, index)"
                                                :move="onDragMove"
                                                style="display: flex; flex-wrap: wrap; overflow: hidden;">
                              <div class="color-handle" v-for="(color, colorIndex) in region" :key="colorIndex"
                                   style="flex: 0 1 40px; margin: 0; box-sizing: border-box;">
                                <div :class="(this.activeColor === color ? 'active': '')"
                                     @click="(event) => { clickColor(color); event.stopPropagation(); }"
                                     class="circle"
                                     :style="{ backgroundColor: color, color: this.getLabelColor(color), width: '40px', height: '40px' }">
                                  {{ this.getColorIndex(index, colorIndex) }}
                                </div>
                              </div>
                            </vue-draggable-next>
                          </div>
                        </div>
                      </vue-draggable-next>
                    </el-scrollbar>
<!--                </template>-->
<!--                <template v-else-if="mode===2">-->
<!--                    <div>-->
<!--                        <el-color-picker v-model="color" :disabled="!color || loading"-->
<!--                                         @change="changeColor"></el-color-picker>-->
<!--                        {{ color }}-->
<!--                    </div>-->
<!--                    <h3>色盘</h3>-->
<!--                    <div>-->
<!--                        <el-scrollbar :max-height="height * unit - 150">-->
<!--                            <div style="display: flex;flex-wrap: wrap">-->
<!--                                <div class="circle" v-for="(g, i) in groups" :style="{backgroundColor: g}"-->
<!--                                     :class="(isDark(g)?'dark':'light') + (active === i?' active':'')"-->
<!--                                     @click="loading?null:changeActive(i)">-->
<!--                                    {{ i + 1 }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </el-scrollbar>-->
<!--                    </div>-->
<!--                </template>-->
            </el-col>
        </el-row>
        <template #footer>
            <el-button text type="primary" @click="close" :loading="loading">取消</el-button>
            <el-tooltip v-if="tooltipContent" class="item" effect="dark" :content="tooltipContent" placement="top">
              <el-button type="primary" @click="submit" :loading="loading"
                 :disabled="image && [1].includes(image.status) || this.remaining_colors.size !== 0">确定
              </el-button>
            </el-tooltip>
            <el-button v-else type="primary" @click="submit" :loading="loading"
                 :disabled="image && [1].includes(image.status) || this.remaining_colors.size !== 0">确定
            </el-button>
        </template>
    </el-dialog>
</template>

<script>
import {VueDraggableNext} from 'vue-draggable-next'
import axios from "ts-axios-new";
import {update} from "../libs/utils";
import {getLocalObj, setLocalObj, cleanLocalObj} from "../libs/storage";
import {render} from "vue";

export default {
    name: "Sort",
    components: {VueDraggableNext},
    data() {
        return {
            image: null, dialog_opened: false, loading: false, unit: 8, width: 0, height: 0, mode: 1, play: 0,
            index: 0, groups: [], image_data: null, color: null, color_changed: false, start: null, duration: 1000,
            // changed: [],
            dragging: false,startX:null, startY:null ,startColor:null, isTracking:false, shiftPressed:false, isAnimationLoopPlaying:false,animationLoopInterval:null, mouse_down: false, selected_region: -1, region_colors: [[]], dragging_region: -1,
            remaining_colors: new Set, activeColor: null, lastActiveColor : null, lastActiveRegion: -1, renderQueueHandler: null,
        }
    },
    methods: {
        init(image) {
            this.image = image;
            this.dialog_opened = this.loading = true;
            // const changed = getLocalObj(`/changed/${this.image.id}`, null);
            // if (changed) {
            //     update(this.changed, changed);
            // }
            const colored = new Image();
            colored.src = `${import.meta.env.VITE_CDN_URL}/${this.image.origin_colored}`;
            colored.crossOrigin = "Anonymous";
            colored.onload = _ => {
                const image_canvas = this.$refs.colored;
                this.width = image_canvas.width = colored.width;
                this.height = image_canvas.height = colored.height;
                const context = image_canvas.getContext('2d');
                context.clearRect(0, 0, image_canvas.width, image_canvas.height);
                context.drawImage(colored, 0, 0);
                const imgData = context.getImageData(0, 0, image_canvas.width, image_canvas.height);
                const data = imgData.data;
                this.image_data  = Array.from(data);
                for (let i = 0; i < data.length; i += 4) {
                    const red = data[i];     // R
                    const green = data[i + 1]; // G
                    const blue = data[i + 2];  // B
                    const gray = 0.299 * red + 0.587 * green + 0.114 * blue;
                    data[i] = gray;       // R
                    data[i + 1] = gray;   // G
                    data[i + 2] = gray;   // B
                }
                context.putImageData(imgData, 0, 0);
                const canvas = this.$refs.canvas;
                canvas.addEventListener('click', (e)=>{
                  this.click(e);
                  this.isTracking = false;
                });
                canvas.addEventListener('mousedown', this.mousedown);
                canvas.addEventListener('mousemove', (e) => {
                  if(this.mouse_down){
                      const dx = e.clientX - this.startX;
                      const dy = e.clientY - this.startY;
                      const distance = Math.sqrt(dx * dx + dy * dy);
                      if(distance > 15){
                        this.isTracking = true;
                      }
                  }
                  this.mousemove(e)
                });
                canvas.addEventListener('mouseup', this.mouseup);
                const colors = []
                for (let i = 0; i < this.image_data.length; i += 4) {
                  if (this.image_data[i + 3]) {
                    const r = this.image_data[i];
                    const g = this.image_data[i + 1];
                    const b = this.image_data[i + 2];
                    if ((r === 255 && g === 255 && b === 255)||(r === 0 && g === 0 && b === 0)){
                      continue
                    }
                    const hex = this.getColor(r,g,b);
                    if (!colors.includes(hex)) {
                      colors.push(hex);
                    }
                  }
                }
                if (this.image.origin_region) {
                    const region = new Image();
                    region.src = `${import.meta.env.VITE_CDN_URL}/${this.image.origin_region}`;
                    region.crossOrigin = "Anonymous";
                    region.onload = _ => {
                        const region_canvas = document.createElement('canvas');
                        region_canvas.width = region.width;
                        region_canvas.height = region.height;
                        const context = region_canvas.getContext('2d');
                        context.drawImage(region, 0, 0);
                        const region_data = context.getImageData(0, 0, region_canvas.width, region_canvas.height).data;
                        const groups = {};
                        for (let i = 0; i < region_data.length; i += 4) {
                            if (region_data[i + 3]) {
                                const index = region_data[i] + region_data[i + 1] * 256 + region_data[i + 2] * 256 ** 2;
                                if (!groups[index]) {
                                    groups[index] = i;
                                }
                            }
                        }
                        Object.keys(groups).forEach(k => {
                            const i = groups[k];
                            const r = this.image_data[i];
                            const g = this.image_data[i + 1];
                            const b = this.image_data[i + 2];
                            const hex = this.getColor(r,g,b);
                            if (colors.includes(hex)) {
                              if (!this.groups.includes(hex)) {
                                this.groups.push(hex);
                              }
                            }
                        });
                        this.onCreated()
                        this.loading = false;
                    }
                } else if(image.colorSort) {
                  this.groups = []
                  const groups = JSON.parse(image.colorSort);
                  groups.forEach(g => {
                    if (colors.includes(g)) {
                      if (!this.groups.includes(g)) {
                        this.groups.push(g);
                      }
                    }
                  })
                  colors.forEach(c => {
                    if (!this.groups.includes(c)) {
                      this.groups.push(c);
                    }
                  })
                  this.onCreated()
                  this.loading = false;
                } else {
                    colors.forEach(c => {
                      if (!this.groups.includes(c)) {
                        this.groups.push(c);
                      }
                    })
                    const cache = getLocalObj(`/region/${this.image.id}`, null);
                    if (cache) {
                      this.groups.sort(function (a, b) {
                        return cache.indexOf(a) - cache.indexOf(b);
                      });
                    }
                    this.onCreated()
                    this.loading = false;
                }
            }
        },
        onCreated() {
            if (!this.image) {
              return
            }
            if (this.image.regions) {
                this.region_colors = JSON.parse(this.image.regions);

            } else {
                const regions = getLocalObj(`/regions/${this.image.id}`, null);
                if (regions) {
                  this.region_colors = regions
                }
            }
            if(this.region_colors.length > 0 && this.region_colors.some(item => item.length > 0) && this.groups.length > 0){
              this.region_colors = this.region_colors.map(region => {
                if(region.length > 0){
                  return region.filter(item => this.groups.includes(item))
                }
                return region;
              })
            }
            this.remaining_colors = new Set(this.groups)
            this.region_colors.forEach(region => {
                region.forEach(color => {
                   this.remaining_colors.delete(color)
                })
            })
            this.postRenderMessage()
        },
        close() {
            this.dialog_opened = this.loading = this.color_changed = false;
            this.mode = 1;
            this.play = this.index = 0;
            this.region_colors = [[]]
            this.selected_region = -1
            this.dragging_region = -1
            this.activeColor = null
            this.mouse_down = false
            this.renderQueueHandler = null
            this.$nextTick(_ => {
              const canvas = this.$refs.colored;
              const ctx = canvas.getContext('2d');
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              this.invalidate()
              this.image = this.image_data = this.color = this.color_data = null;
                // this.active = -1;
            });
            // cleanLocalObj(`/changed/${this.image.id}`);
            this.groups = [];
            // this.changed = [];
        },
        submit() {
            if (this.remaining_colors.size > 0) {
               alert("还没完成排序")
               return
            }
            this.loading = true;
            this.groups = this.getSortedList()
            const region = document.createElement('canvas');
            region.width = this.width;
            region.height = this.height;
            const ctx = region.getContext('2d');
            const data = ctx.getImageData(0, 0, region.width, region.height);
            for (let i = 0; i < this.image_data.length; i += 4) {
                if (this.image_data[i + 3]) {
                    const r = this.image_data[i];
                    const g = this.image_data[i + 1];
                    const b = this.image_data[i + 2];
                    if (r === 255 && g === 255 && b === 255) {
                        continue
                    }
                    const hex = this.getColor(r,g,b);
                    const index = this.groups.indexOf(hex) + 1;
                    data.data[i] = index % 256;
                    data.data[i + 1] = Math.floor(index / 256);
                    data.data[i + 2] = Math.floor(index / 256 ** 2);
                    data.data[i + 3] = 255;
                }
            }
            ctx.putImageData(data, 0, 0);
            const form = new FormData();
            region.toBlob(blob => {
                form.append('file', blob, 'image.png')
                // if (this.color_changed) {
                //     this.$refs.colored.toBlob(b => {
                //         form.append('colored', b, 'colored.png');
                //         this.put(form);
                //     })
                // } else {
                this.put(form);
                // }
            })
        },
        put(form) {
          const regions = JSON.stringify(this.region_colors)
          const blob = new Blob([regions], { type: 'application/json' });
          // form.append('sort', blob, "sort.json");
          form.append('regions', blob, "regions.json");
          axios.put(`/cms/v1/region/${this.image.id}`, form).then(res => {
                cleanLocalObj(`/regions/${this.image.id}`);
                update(this.image, res.data.data);
                this.image.regions = regions
                this.image.status = 0;
                this.close();
          });
        },
        click(e) {
            if(this.isAnimationLoopPlaying){
              this.stopAutoSequence()
            }
            if (this.dragging)
                return
            if (!e.metaKey && !e.ctrlKey) {
                const canvas = this.$refs.canvas;
                const rect = canvas.getBoundingClientRect();
                const offset_x = rect.left;
                const offset_y = rect.top;
                const x = Math.round((e.clientX - 4 - offset_x) * canvas.width / canvas.clientWidth);
                const y = Math.round((e.clientY - 4 - offset_y) * canvas.height / canvas.clientHeight);
                const i = this.width * y * 4 + x * 4;
                const hex = this.getColor(this.image_data[i], this.image_data[i + 1], this.image_data[i + 2]);
                if (this.mode === 1) {
                    this.selectColor(hex,'click')
                }
            } else {
                const canvas = this.$refs.canvas;
                const rect = canvas.getBoundingClientRect();
                const offset_x = rect.left;
                const offset_y = rect.top;
                // const x = Math.round((e.clientX  - offset_x) / this.scale * canvas.width / canvas.clientWidth);
                // const y = Math.round((e.clientY  - offset_y) / this.scale * canvas.height / canvas.clientHeight);
                const x = Math.round((e.clientX - 4 - offset_x) * canvas.width / canvas.clientWidth);
                const y = Math.round((e.clientY - 4 - offset_y) * canvas.height / canvas.clientHeight);
                const i = this.width * y * 4 + x * 4;
                const hex = this.getColor(this.image_data[i], this.image_data[i + 1], this.image_data[i + 2]);
                // this.clean(x, y);
                if (this.mode === 1) {
                    this.unselectColor(hex)
                }
            }
            this.startColor = null; 
            // requestAnimationFrame(this.render);
        },
        getColorIndex(regionIndex, colorIndex) {
            let index = colorIndex + 1
            for(let i = 0; i < regionIndex; i++) {
                index += this.region_colors[i].length
            }
            return index
        },
        // getRegion(x, y, reverse) {
        //     const canvas = this.$refs.canvas;
        //     const ctx = canvas.getContext('2d');
        //     ctx.clearRect(0, 0, canvas.width, canvas.height);
        //     const i = this.width * y * 4 + x * 4;
        //     this.color = null;
        //     if (i < 0 || this.image_data[i + 3] === 0)
        //         return
        //     const r = this.image_data[i];
        //     const g = this.image_data[i + 1];
        //     const b = this.image_data[i + 2];
        //     if (r === 255 && g === 255 && b === 255)
        //         return
        //     this._getDFRegion(r, g, b, x, y, reverse);
        //     if (this.selected.length === 0) {
        //         this.active = -1;
        //         this.color = null;
        //     }
        //     this.color = `#${this.convHex(r)}${this.convHex(g)}${this.convHex(b)}`;
        // },
        _getDFRegion(r, g, b, x, y, reverse) {
            const i = this.width * y * 4 + x * 4;
            if (this.image_data[i + 3] === 0 || this.image_data[i] !== r || this.image_data[i + 1] !== g || this.image_data[i + 2] !== b || !reverse && this.selected.includes(i) || reverse && !this.selected.includes(i)) {
                return
            }
            if (reverse) {
                if (this.selected.includes(i))
                    this.selected.splice(this.selected.indexOf(i), 1);
            } else {
                if (!this.selected.includes(i))
                    this.selected.push(i);
            }
            if (x > 0) {
                this._getDFRegion(r, g, b, x - 1, y, reverse);
            }
            if (y > 0) {
                this._getDFRegion(r, g, b, x, y - 1, reverse);
            }
            if (x < this.width - 1) {
                this._getDFRegion(r, g, b, x + 1, y, reverse);
            }
            if (y < this.height - 1) {
                this._getDFRegion(r, g, b, x, y + 1, reverse);
            }
        },
        clickColor(color) {
            if (this.activeColor === color) {
                this.lastActiveColor = this.activeColor
                this.activeColor = null
            } else {
                this.activeColor = color
                this.postRenderMessage()
            }
        },
        getSortedList() {
            const sorted_list = []
              for (let r = 0; r < this.region_colors.length; r++) {
                  const colors = this.region_colors[r]
                  colors.forEach(color => {
                    if (this.groups.includes(color)) {
                       sorted_list.push(color)
                    }
                  })
              }
            return sorted_list
        },
        saveChange() {
          // const sorted_list = this.getSortedList()
          // setLocalObj(`/region/${this.image.id}`, sorted_list);
          setLocalObj(`/regions/${this.image.id}`, this.region_colors);
          // setLocalObj(`/changed/${this.image.id}`, this.changed);
        },
        invalidate() {
            const canvas = this.$refs.canvas;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        },
        changeActive(e,i) {
          this.lastActiveRegion = i;
          if (this.isAnimationLoopPlaying){
            this.stopAutoSequence() 
          }
          if (e.shiftKey){
            if (this.selected_region === i) {
                this.selected_region = -1
            } else {
                this.selected_region = i
                this.startAutoSequence(i)
            }
          } else {
            if (this.selected_region === i) {
              this.selected_region = -1
            } else {
                this.selected_region = i
            }
            this.invalidate()
            this.postRenderMessage();
          }
        },
        startAutoSequence(i){
          this.stopAutoSequence()
          if (!this.region_colors[i] || this.region_colors[i].length === 0) {
            console.error("无效的颜色序列", i);
            return;
          }
          this.isAnimationLoopPlaying = true;
          let index = 0;
          this.animationLoopInterval = setInterval(() => {
            const color = this.region_colors[i][index];
            this.clickColor(color);
            index = (index + 1) % this.region_colors[i].length;
          }, 200); 
        },
        stopAutoSequence() {
          clearInterval(this.animationLoopInterval);
          this.animationLoopInterval = null;
          this.isAnimationLoopPlaying = false;
          this.activeColor = null; 
        },
        beforeDestroy() {
          this.stopAutoSequence();
        },
        unselectColor(color) {
            let index = this.groups.indexOf(color)
            if (index < 0) {
              return;
            }
            for (let i = 0; i < this.region_colors.length; i++) {
                const index = this.region_colors[i].indexOf(color);
                if (index !== -1) {
                  this.region_colors[i].splice(index, 1);
                  if(this.region_colors[i].length===0){
                    this.region_colors.splice(i,1);
                  }
                  this.remaining_colors.add(color);
                  this.invalidate();
                  this.postRenderMessage();
                  return;
                }
            }
        },
        onDragStart(e) {
            this.draggedItem = null
            this.targetIndex = -1
        },
        onDragMove(e) {
            const index = e.draggedContext.index;
            const list = e.relatedContext.list
            this.draggedItem = list[index]
            this.targetIndex = e.relatedContext.index
        },
        onDragEnd(e, i) {
            const list = (i === -1) ? this.region_colors : this.region_colors[i]
            if (this.draggedItem) {
              list.splice(list.indexOf(this.draggedItem), 1)
              list.splice(this.targetIndex, 0 , this.draggedItem)
            }
        },
        nextRegion() {
            // for (let i = 0; i <  this.region_colors.length; i++) {
            //     if ( this.region_colors[i].length === 0 ) {
            //       return i
            //     }
            // }
            this.region_colors.push([])
            return this.region_colors.length - 1
        },
        selectColor(color, type) {
            let index = this.groups.indexOf(color)
            if (index < 0) {
                return
            }
            const regionIndex = this.findColorPosition(this.region_colors,color);
            if(regionIndex >= 0){
              if(type ==='click' && !this.isTracking && (this.startColor || this.startColor === null)){
                const element = document.getElementById(`item-${regionIndex}`);
                if(element){
                  element.scrollIntoView({
                    behavior: 'smooth', 
                    block: 'nearest'    
                  });
                }
                this.clickColor(color)
              }
            }else{
              let target_region = (0 <= this.selected_region) ? this.selected_region:
                  ( 0 <= this.dragging_region ? this.dragging_region : this.nextRegion())
              if (target_region >= 0) {
                  this.activeColor = null
                  this.region_colors[target_region].push(color);
                  this.lastActiveRegion = target_region;
                  this.$nextTick(()=>{
                    const element =document.getElementById(`item-${this.lastActiveRegion}`);
                    if(element){
                      element.scrollIntoView({
                        behavior: 'smooth', 
                        block: 'nearest'    
                      });
                    }
                  })
                  this.remaining_colors.delete(color)
                  this.invalidate()
                  this.postRenderMessage()
              }
            }
        },
        postRenderMessage() {
            if (!this.renderQueueHandler) {
                this.renderQueueHandler = requestAnimationFrame(this.render)
            }
        },
        render(currentTime) {
          if (!this.$refs.canvas)
            return
          if (!this.start) {
              this.start = currentTime;
          }
          const canvas = this.$refs.canvas;
          const ctx = canvas.getContext('2d');
          const data = ctx.getImageData(0, 0, canvas.width, canvas.height);
          let colors = new Set()
          for (let r = 0; r < this.region_colors.length; r++) {
            this.region_colors[r].forEach(color => {
                // const {r, g, b} = this.getRGB(this.groups[labels[label]]);
                // const color = this.getColor(r, g, b)
              // const luminosity = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
              colors.add(color)
            })
          }
          for (let i = 0; i < this.image_data.length; i += 4) {
            //     if (this.image_data[i + 3]) {
              const color = this.getColor(this.image_data[i], this.image_data[i + 1], this.image_data[i + 2])
              // if (this.image_data[i] === r && this.image_data[i + 1] === g && this.image_data[i + 2] === b) {
                // data.data[i] = luminosity < 0.5 ? 255 : 0;
                // data.data[i + 1] = luminosity < 0.5 ? 255 : 0;
                // data.data[i + 2] = luminosity < 0.5 ? 255 : 0;
                // data.data[i + 3] = Math.round(alpha * 255);
              if (colors.has(color)) {
                  data.data[i] = this.image_data[i];
                  data.data[i + 1] = this.image_data[i + 1];
                  data.data[i + 2] = this.image_data[i + 2];
                  data.data[i + 3] = Math.round(255);
                // }
              }
              if (this.activeColor === color) {
                  const elapsedTime = currentTime - this.start;
                  const progress = (elapsedTime % this.duration) / this.duration;
                  const alpha = Math.abs(Math.sin(progress * Math.PI));
                  const luminosity = (0.299 * this.image_data[i] + 0.587 * this.image_data[i+2] + 0.114 * this.image_data[i+2]) / 255;
                  data.data[i] = luminosity < 0.5 ? 255 : 0;
                  data.data[i + 1] = luminosity < 0.5 ? 255 : 0;
                  data.data[i + 2] = luminosity < 0.5 ? 255 : 0;
                  data.data[i + 3] = Math.round(alpha * 255);
              } else if (this.lastActiveColor === color) {
                  const regionIndex = this.findColorPosition(this.region_colors,color)
                  data.data[i + 3] = regionIndex >= 0 ? Math.round(255) : Math.round(0);
              }
          }
          ctx.putImageData(data, 0, 0);
          if (this.activeColor) {
              this.renderQueueHandler = null
              this.postRenderMessage();
          } else {
              this.renderQueueHandler = null
          }
          this.lastActiveColor = null
        },
        getLabelColor(color) {
            const rgb = this.getRGB(color)
            const luminosity = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
            if (luminosity < 0.5) {
              return "white"
            } else {
              return "black"
            }
        },
        // animate(currentTime) {
        //     if (!this.$refs.canvas)
        //         return
        //     if (!this.start) {
        //         this.start = currentTime;
        //     }
        //     if (this.play === 1) {
        //         requestAnimationFrame(this.animate);
        //         return
        //     }
        //     // if (this.selected_region < 0 || this.selected_region >= this.region_labels.length){
        //     //     requestAnimationFrame(this.animate);
        //     //     return
        //     // }
        //     const canvas = this.$refs.canvas;
        //     const ctx = canvas.getContext('2d');
        //     const elapsedTime = currentTime - this.start;
        //     const progress = (elapsedTime % this.duration) / this.duration;
        //
        //     // 计算当前颜色的透明度
        //     // const alpha = Math.abs(Math.sin(progress * Math.PI));
        //     const data = ctx.getImageData(0, 0, canvas.width, canvas.height);
        //     if (this.mode === 1) {
        //         for (let r = 0; r < this.region_labels.length; r++) {
        //             console.log("dddd " + r)
        //             const labels = this.region_labels[r]
        //             for (let label = 0; label < labels.length; label++) {
        //                 const color = this.groups[labels[label]];
        //                 const {r, g, b} = this.getRGB(color);
        //                 // const luminosity = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        //                 for (let i = 0; i < this.image_data.length; i += 4) {
        //                 //     if (this.image_data[i + 3]) {
        //                     if (this.image_data[i] === r && this.image_data[i + 1] === g && this.image_data[i + 2] === b) {
        //                             // data.data[i] = luminosity < 0.5 ? 255 : 0;
        //                             // data.data[i + 1] = luminosity < 0.5 ? 255 : 0;
        //                             // data.data[i + 2] = luminosity < 0.5 ? 255 : 0;
        //                             // data.data[i + 3] = Math.round(alpha * 255);
        //                         data.data[i] = r;
        //                         data.data[i + 1] = g;
        //                         data.data[i + 2] = b;
        //                         data.data[i + 3] = Math.round(255);
        //                         // }
        //                     }
        //                 }
        //             }
        //         }
        //         ctx.putImageData(data, 0, 0);
        //     } else if (this.mode === 2 && this.selected.length > 0) {
        //         const {r, g, b} = this.getRGB(this.color);
        //         const luminosity = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        //         this.selected.forEach(i => {
        //             data.data[i] = luminosity < 0.5 ? 255 : 0;
        //             data.data[i + 1] = luminosity < 0.5 ? 255 : 0;
        //             data.data[i + 2] = luminosity < 0.5 ? 255 : 0;
        //             data.data[i + 3] = Math.round(alpha * 255);
        //         });
        //         ctx.putImageData(data, 0, 0);
        //     }
        //     // 循环调用动画函数
        //     // console.log("requestAnimationFrame ")
        //     requestAnimationFrame(this.animate);
        // },
        isDark(color) {
            const {r, g, b} = this.getRGB(color);
            // 计算颜色亮度
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            // 比较亮度和阈值
            return brightness < 128;
        },
        getRGB(color) {
            const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
            // 提取红、绿、蓝分量的值
            const r = parseInt(rgb[1], 16);
            const g = parseInt(rgb[2], 16);
            const b = parseInt(rgb[3], 16);
            return {r, g, b};
        },
        getColor(r,g,b) {
          return `#${this.convHex(r)}${this.convHex(g)}${this.convHex(b)}`;
        },
        convHex(int) {
          return int.toString(16).padStart(2, '0').toUpperCase();
        },
        clearColor(){
          this.$confirm('此操作将清除所有颜色, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.region_colors = []
              this.remaining_colors = new Set(this.groups)
              this.invalidate()
              this.saveChange()
              this.$message({
                type: 'success',
                message: '清除成功!'
              });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消清除'
              });          
            });
          },
        tryToColor() {
            this.play = 1;
            this.index = 0;
            const canvas = this.$refs.colored;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            this.invalidate()
            this.drawColor();
        },
        pauseColor() {
            this.play = 2;
        },
        continueColor() {
            this.invalidate()
            this.play = 1;
            this.drawColor();
        },
        drawColor() {
            setTimeout(_ => {
                if (this.play === 2 || this.play === 0)
                    return
                const sortedList = this.getSortedList()
                const {r, g, b} = this.getRGB(sortedList[this.index]);
                const canvas = this.$refs.colored;
                const ctx = canvas.getContext('2d');
                const data = ctx.getImageData(0, 0, canvas.width, canvas.height);
                for (let i = 0; i < this.image_data.length; i += 4) {
                    if (this.image_data[i] === r && this.image_data[i + 1] === g && this.image_data[i + 2] === b && this.image_data[i + 3] === 255) {
                        data.data[i] = r;
                        data.data[i + 1] = g;
                        data.data[i + 2] = b;
                        data.data[i + 3] = 255;
                    }
                }
                ctx.putImageData(data, 0, 0);
                // this.active = this.index;
                this.index++;
                if (this.index >= sortedList.length) {
                    this.play = 0;
                } else {
                    this.drawColor();
                }
            }, 400);
        },
        mousedown(e) {
          this.mouse_down = true;
          this.startX = e.clientX;
          this.startY = e.clientY;
        },
        mousemove(e) {
          if (!this.mouse_down) {
            return
          }
          this.dragging = true
          if (!e.metaKey && !e.ctrlKey) {
            const canvas = this.$refs.canvas;
            const rect = canvas.getBoundingClientRect();
            const offset_x = rect.left;
            const offset_y = rect.top;
            const x = Math.round((e.clientX - 4 - offset_x) * canvas.width / canvas.clientWidth);
            const y = Math.round((e.clientY - 4 - offset_y) * canvas.height / canvas.clientHeight);
            const i = this.width * y * 4 + x * 4;
            const hex = this.getColor(this.image_data[i], this.image_data[i + 1], this.image_data[i + 2]);
            if(this.startColor === null){
              const regionIndex = this.findColorPosition(this.region_colors,hex);
              if(regionIndex >= 0){
                this.startColor = true;
              }else{
                this.startColor = false;
              }
            }
            if (this.mode === 1) {
              if (this.selected_region <= -1 && this.dragging_region <= -1) {
                this.dragging_region = this.nextRegion()
              }
              this.selectColor(hex,'mousemove')
            }
          } else {
            const canvas = this.$refs.canvas;
            const rect = canvas.getBoundingClientRect();
            const offset_x = rect.left;
            const offset_y = rect.top;
            // const x = Math.round((e.clientX  - offset_x) / this.scale * canvas.width / canvas.clientWidth);
            // const y = Math.round((e.clientY  - offset_y) / this.scale * canvas.height / canvas.clientHeight);
            const x = Math.round((e.clientX - 4 - offset_x) * canvas.width / canvas.clientWidth);
            const y = Math.round((e.clientY - 4 - offset_y) * canvas.height / canvas.clientHeight);
            const i = this.width * y * 4 + x * 4;
            const hex = this.getColor(this.image_data[i], this.image_data[i + 1], this.image_data[i + 2]);
            // this.clean(x, y);
            if (this.mode === 1) {
              this.unselectColor(hex)
            }
          }
            // if (this.highlight) {
            //     this.dragging = true;
            //     const rectangle = document.getElementById('rectangle');
            //     const {x, y} = rectangle.getBoundingClientRect();
            //     this.x1 = e.clientX - 4 - x;
            //     this.y1 = e.clientY - 4 - y;
            //     const w = Math.abs(this.x1 - this.x0);
            //     const h = Math.abs(this.y1 - this.y0);
            //     this.highlight.style.width = w + 'px';
            //     this.highlight.style.height = h + 'px';
            //     this.highlight.style.left = Math.min(this.x0, this.x1) + 'px';
            //     this.highlight.style.top = Math.min(this.y0, this.y1) + 'px';
            // } else if (this.mode === 2 && this.active > -1 && e.buttons === 1) {
            //     const rectangle = document.getElementById('rectangle');
            //     const {x, y} = rectangle.getBoundingClientRect();
            //     this.x0 = e.clientX - 4 - x;
            //     this.y0 = e.clientY - 4 - y;
            //     const highlight = this.highlight = document.createElement('div');
            //     highlight.id = 'highlight';
            //     rectangle.appendChild(highlight);
            // }
        },
        mouseup(e) {
          this.mouse_down = false
          this.dragging = false
          if(!this.shiftPressed){
            this.dragging_region = -1;
          }
          this.saveChange()
            // if (this.highlight && this.active > -1) {
            //     const rectangle = document.getElementById('rectangle');
            //     rectangle.removeChild(this.highlight);
            //     this.highlight = null;
            //     const color = this.groups[this.active];
            //     const {r, g, b} = this.getRGB(color);
            //     const reverse = e.ctrlKey || e.metaKey;
            //     for (let x = Math.round(Math.min(this.x0, this.x1) / this.unit); x < Math.round(Math.max(this.x0, this.x1) / this.unit); x++) {
            //         for (let y = Math.round(Math.min(this.y0, this.y1) / this.unit); y < Math.round(Math.max(this.y0, this.y1) / this.unit); y++) {
            //             const i = this.width * y * 4 + x * 4;
            //             if (this.image_data[i + 3] === 0 || this.image_data[i] !== r || this.image_data[i + 1] !== g || this.image_data[i + 2] !== b || !reverse && this.selected.includes(i) || reverse && !this.selected.includes(i)) {
            //                 continue
            //             }
            //             if (reverse) {
            //                 if (this.selected.includes(i))
            //                     this.selected.splice(this.selected.indexOf(i), 1);
            //             } else {
            //                 if (!this.selected.includes(i))
            //                     this.selected.push(i);
            //             }
            //         }
            //     }
            //     const canvas = this.$refs.canvas;
            //     const ctx = canvas.getContext('2d');
            //     ctx.clearRect(0, 0, canvas.width, canvas.height);
            //     this.color = this.getColor(r,g,b);
            //     this.active = this.groups.indexOf(this.color);
            // }
            // if (this.dragging) {
            //     setTimeout(_ => {
            //         this.dragging = false;
            //
            //
            //     }, 100);
            // }
        },
        handleKeyDown(e) {
          if(e.key === 'Shift'){
            this.shiftPressed = true;
          }
          if (e.key === 'Q' || e.key === 'q'){
            if (this.activeColor){
              const index = this.findColorPosition(this.region_colors,this.activeColor);
              if(this.selected_region === index){   
                this.selected_region = -1;
              }else { 
                this.selected_region = index;
                this.lastActiveRegion = index;
              }
            }else{ 
              if(this.selected_region > -1){
                this.selected_region = -1;
              }else{
                if(this.lastActiveRegion > -1){
                  this.selected_region = this.lastActiveRegion;
                }else{
                  this.selected_region = this.region_colors.length - 1;
                  this.lastActiveRegion = this.selected_region;
                }
              }
            }
          }
        },
        handleKeyUp(e){
          if (e.key === 'Shift') {
            this.shiftPressed = false;
            if (!this.mouse_down) {
              this.dragging_region = -1;
            }
          }
        },
        findColorPosition (arr,targetColor){
          return arr.findIndex(subArray => subArray.includes(targetColor))
        }
    },
    computed: {
      tooltipContent() {
        if (this.image && [1].includes(this.image.status)) {
          return "状态已通过"; 
        } else if (this.remaining_colors.size !== 0) {
          return "还有未排序颜色"; 
        } else {
          return "";  
        }
      },
    },
    mounted() {
      window.addEventListener('keydown',this.handleKeyDown);
      window.addEventListener('keyup',this.handleKeyUp);
    },
    beforeDestroy(){
      window.removeEventListener('keydown',this.handleKeyDown);
      window.addEventListener('keyup',this.handleKeyUp);
    },
}
</script>

<style scoped>
.color-section{
  padding: 6px;
  border-radius: 10px;
  margin: 6px;
  flex: 1;
  border:1px solid #c9c9c9;
}
.section-acitve{
  border-color: red;
  box-shadow: 
    0 0 0 4px rgba(255, 100, 113, 0.523), 
    0 0 0 4px rgba(255, 119, 119, 0.801);    
}
.handle.active {
    background-color: #CEFFA8;
}

.circle {
    width: 40px;
    height: 40px;
    margin: 4px;
    border-radius: 50%;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    font-weight: bold;
    border: 1px solid var(--el-color-info-light-3);
    opacity: 1;
}

.circle.active {
    font-size: 18px;
    margin: 0;
    border: 5px solid var(--el-color-primary);
}

.circle.light {
    color: #606266;
}

.circle.dark {
    color: #EBEEF5
}

#colored, #region {
    image-rendering: pixelated;
}
</style>